import { useQuery } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export default function useFloatCandidates() {
  const api = useAxios();

  const { data } = useQuery({
    queryKey: ["float-candidates"],
    queryFn: () => api.get("/floats/candidates"),
    staleTime: 5 * 60 * 1000,
    throwOnError: false,
  });

  return { candidates: data?.data ?? [] };
}
